export default __webpack_public_path__ + "static/media/patty_cooked.097ee37d.svg";